<template>
  <div class="description">
    <p class="description__text fs-36" data-split>
      {{ description }}
    </p>
  </div>
</template>

<script setup>
const props = defineProps({
  description: { type: String, default: null },
});
</script>

<style lang="scss" scoped>
.description__text {
  @include mq(desktop) {
    width: 60%;
  }
  // display: flex;
}
</style>
